import { useCallback } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { QuoteTabKey } from '../../models/quotes/quote-tab.interface';

const validTabKeys: QuoteTabKey[] = [
  'quoteRequests',
  'pendingForApproval',
  'approved',
  'rejected',
  'cancelled',
  'audit'
];

function isQuoteTabKey(value: string | null): value is QuoteTabKey {
  return !!value && (validTabKeys as string[]).includes(value);
}

// Same `tab` query-param-as-source-of-truth shape as useShipmentTabParam.ts
// (plan §7) - preserves location.state on write so the breadcrumb set by
// side-nav/Home-card navigation survives the first tab click.
export function useQuoteTabParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const rawTab = searchParams.get('tab');
  const activeTab: QuoteTabKey = isQuoteTabKey(rawTab)
    ? rawTab
    : 'quoteRequests';

  const setActiveTab = useCallback(
    (tab: QuoteTabKey) => {
      const next = new URLSearchParams(searchParams);
      next.set('tab', tab);
      setSearchParams(next, { state: location.state });
    },
    [searchParams, setSearchParams, location.state]
  );

  return { activeTab, setActiveTab };
}

export default useQuoteTabParam;
